module.exports = __webpack_public_path__ + "static/media/29ADMSPC29.9aa3e709.jpg";